import './i18n';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import './components/styles'; // styles/index.jsを参照
import AppWrapper from './AppWrapper'; // AppWrapperをインポート


const rootElement = document.getElementById('root');
const root = ReactDOM.createRoot(rootElement); // 修正: createRoot を使用

root.render(
  <React.StrictMode>
    <AppWrapper />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
